<div class="pageheader">
  <div class="page-title">
    <h1>Incoming transport location</h1>
    <div class="btn-group">
      <button type="button" class="btn btn-link" [disabled]="!InViewMode" (click)="refresh()">
        Refresh <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
      <app-change-log-link *bizPermissionRequired="'Transport_Action_IncomingLocation_ShowLog'" [disabled]="!InViewMode"
        [title]="'Logs for ' + $safeNavigationMigration(selectedTransportConfiguration?.Name)">
        <app-change-log-link-entity type="TransportInConfiguration" [id]="$safeNavigationMigration(selectedTransportConfiguration?.Id)">
        </app-change-log-link-entity>
        <app-change-log-link-entity type="InitConfiguration" [id]="$safeNavigationMigration(selectedTransportConfiguration?.InitConfiguration?.Id)"></app-change-log-link-entity>
        <app-change-log-link-entity type="ScheduledItem" [id]="$safeNavigationMigration(selectedTransportConfiguration?.Schedule?.Id)">
        </app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<!-- Multi-locations -->
@if (transportConfigurations.length >= 2) {
  <div class="row">
    <div class="col-md-12 mb-2">
      <div data-toggle="buttons">
        @for (transportConfiguration of transportConfigurations; track transportConfiguration) {
          <label class="btn btn-info-button"
            [class.active]="selectedTransportConfiguration?.Id === transportConfiguration.Id">
            <input [disabled]="InEditMode" type="radio" [value]="transportConfiguration" [ngModel]="selectedTransportConfiguration"
              (ngModelChange)="select(transportConfiguration)">
              <span class="id">
                {{transportConfiguration.Name}}
                <button type="button" class="btn btn-sm pull-right" [disabled]="InEditMode" (click)="remove(transportConfiguration.Id)">
                  &times;
                </button>
              </span>
              <span class="hr"></span>
              <span>{{ transportConfiguration.Transport?.Name }}</span>
              <span>{{ transportConfiguration.DisplayAddress }}</span>
            </label>
          }
        </div>
      </div>
    </div>
  }

  <form [formGroup]="formModel" (ngSubmit)="onSave()" novalidate>
    <dx-validation-group #vg>
      <!-- Top Toolbar -->
      <div class="row mb-2">
        <div class="col-sm-12">
          <div class="btn-toolbar">
            @if (!InNewMode) {
              <div class="btn-group">
                <button type="button" class="btn btn-primary btn-sm" [disabled]="!InViewMode"
                  *bizPermissionRequired="'Transport_Action_IncomingLocation_Edit'"
                (click)="onEdit($event)">Edit</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-primary btn-sm" [disabled]="!InViewMode"
                  *bizPermissionRequired="'Transport_Action_IncomingLocation_Delete'"
                (click)="onDelete($event)">Delete</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-primary btn-sm"
                  *bizPermissionRequired="'Transport_Action_IncomingLocation_Edit'"
                [disabled]="!InViewMode" (click)="onTriggerNow($event)">Trigger now</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-primary btn-sm" (click)="onShowInitConfig($event)">{{
                InViewMode ? 'Show init-config' : 'Edit init-config'}}</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-primary btn-sm" [disabled]="!InViewMode"
                  (click)="navigateToLog($safeNavigationMigration(selectedTransportConfiguration?.Id))">
                  Show transport log
                </button>
              </div>
              <div class="btn-group">
                <button class="btn btn-primary btn-sm" id="btnUpload"
                  *bizPermissionRequired="'Tracking_Action_UploadDocument'" [disabled]="!InViewMode"
                  (click)="uploadTestFile()">
                  Upload test file
                </button>
              </div>
            }
          </div>

        </div>
      </div>

      <!-- Enabled -->
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <div class="control control-checkbox">
              <label>
                Enabled
                <input formControlName="enabled" type="checkbox" />
                <i></i>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Name / Type / Interval -->
      <div class="row">
        <div class="col-sm-7 col-lg-7">
          <div class="form-group">
            <label class="form-required">Name</label>
            <input formControlName="name" type="text" class="form-control" [bizFocus]="true"
              [class.invalid-state-border]="fcName.invalid" required />
              <div class="error" [class.invisible]="!fcName.invalid || (!fcName.dirty && !fcName.touched)">
                @if (fcName.errors?.nameExists) {
                  <p>Name is already used</p>
                }
                @if (fcName.errors?.required) {
                  <p>Name is required</p>
                }
              </div>
            </div>
          </div>
          <div class="col-sm-5 col-lg-2">
            <div class="form-group">
              <label class="form-required">Transport type</label>
              <select class="form-control" formControlName="transportTypeId"
                [class.invalid-state-border]="fcTransportTypeId.invalid" required>
                <option [ngValue]="null">Please choose...</option>
                @for (transportType of transportTypes; track transportType) {
                  <option [ngValue]="transportType.Id">
                    {{ transportType.Name }}
                  </option>
                }
              </select>
              <div class="error"
                [class.invisible]="!fcTransportTypeId.invalid || (!fcTransportTypeId.dirty && !fcTransportTypeId.touched)">
                <div>Transport type is required</div>
              </div>
            </div>
          </div>
          <div class="col-sm-5 col-lg-3">
            <div class="form-group">
              <label class="form-required">Polling interval</label>
              <ep-duration-picker innerClass="form-control" formControlName="frequency"
              [invalid]="fcFrequency.invalid"></ep-duration-picker>
              <div class="error"
                [class.invisible]="!fcFrequency.invalid || (!fcFrequency.dirty && !fcFrequency.touched)">
                @if (fcFrequency.errors?.required) {
                  <div>Frequency is required</div>
                }
                @if (fcFrequency.errors?.min) {
                  <div>Minimum value is 30 seconds</div>
                }
                @if (!fcFrequency.errors?.required && !fcFrequency.errors?.min) {
                  <div>
                  Error</div>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- Schedule -->
        <div class="row">
          <div class="col-sm-12">
            @if (selectedTransportConfiguration?.Schedule) {
              <ep-schedule-item #transportSchedule
                [scheduleItem]="$safeNavigationMigration(selectedTransportConfiguration?.Schedule)" [readonly]="InViewMode"
                [validateTriggerTimes]="true" [requireWeekdaySelection]="true">
              </ep-schedule-item>
            }
            @if (selectedTransportConfiguration?.Schedule?.Triggers?.length === 0) {
              <div>
                Polling will be active 24/7/365. To restrict this, add a trigger above.
              </div>
            }

            @if (selectedTransportConfiguration?.Schedule?.Triggers?.length > 0) {
              <hr />
            }
          </div>
        </div>

        <!-- DataField Groups -->
        <div class="row mb-2">
          <div class="col-sm-12">
            <ep-datafield-group-container #dfgc [formValidationGroup]="dataFieldsFormGroup" [showError]="true"
              [datafieldGroups]="dataFieldGroups" [isAlwaysEditable]="!InViewMode" [numberOfColumns]="2">
            </ep-datafield-group-container>
          </div>
        </div>

        <!-- Monitor -->
        @if (selectedTransportConfigurationHasMonitor) {
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="embeddedItem">
                <h2>Monitoring</h2>
                <app-monitor-item-edit formControlName="monitorItem" [stakeholders]="stakeholders"
                  [monitorSchedules]="monitorSchedules" [monitorGroups]="monitorGroups"
                  [embeddedArtifactId]="getSelectedTransportTypeArtifactId()">
                </app-monitor-item-edit>
              </div>
            </div>
          </div>
        }
        @if (InEditMode || InNewMode) {
          @if ((currentTransportTypeHasEmbeddedMonitor$ | async) || selectedTransportConfigurationHasMonitor) {
            <div class="row mb-2"
              >
              <div class="col-sm-12">
                <div class="btn-toolbar">
                  <button type="button" class="btn btn-primary"
                    [disabled]="selectedTransportConfigurationHasMonitor" (click)="addMonitor()">Add
                  monitor</button>
                  <button type="button" class="btn btn-primary"
                    [disabled]="!selectedTransportConfigurationHasMonitor" (click)="removeMonitor()">Remove
                  monitor</button>
                </div>
              </div>
            </div>
          }
        }

        <!-- Bottom Toolbar -->
        <div class="row mb-2">
          <div class="col-sm-12">
            <div class="modal-footer btn-toolbar">
              @if (InViewMode) {
                <div class="btn-group">
                  <button type="button" class="btn btn-primary btn-sm"
                    *bizPermissionRequired="'Transport_Action_IncomingLocation_Edit'" [disabled]=""
                    (click)="onEdit($event)">
                    Edit
                  </button>
                </div>
              }
              @if (InEditMode || InNewMode) {
                <div class="btn-group">
                  <button type="submit" class="btn btn-primary btn-sm" [disabled]="!canSave()">Save</button>
                </div>
                <div class="btn-group">
                  <button type="button" class="btn btn-primary btn-sm" (click)="onCancel($event)">
                    Cancel
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </dx-validation-group>
    </form>
